import React from 'react';
import {Swiper, SwiperSlide} from "swiper/react";
import 'swiper/css';
import styled from "styled-components";

import {useAppSelector} from "../../hooks/hooks";
import SliderItem from "../CodesScreen/SliderItem";


const Slider: React.FC = () => {
    const codesData = useAppSelector((state) => state.tutorial.codes)

    return (
        <Container>
            {codesData.length &&
                <Swiper
                    initialSlide={codesData.length - 1}
                    spaceBetween={8}
                    slidesPerView={"auto"}
                    centeredSlides={true}
                >
                    {codesData && codesData.map((code, index) => <StyledSwiperSlide key={index}><SliderItem code={code}/></StyledSwiperSlide>)}
                </Swiper>
            }
        </Container>
    );
};

export default Slider;

const Container = styled.div`
    margin-top: 12px;
`
const StyledSwiperSlide = styled(SwiperSlide)`
    width: 90%;
    padding: 18px 0 0;
`;
